import ReactDiffViewer from "react-diff-viewer-continued";
import { useIsDarkMode } from "@/hooks/use-is-dark-mode";
import type { AuditLogItem } from "../types";
import { stableStringify } from "../utils/stable-stringify";

type AuditLogDiffProps = {
  log: AuditLogItem;
};

const diffStyles = {
  diffContainer: {
    tableLayout: "auto" as const,
    minWidth: "unset",
  },
};

export const AuditLogDiff = ({ log }: AuditLogDiffProps) => {
  const isDarkMode = useIsDarkMode();

  if (!log.data?.updated) {
    return null;
  }

  const { original, updated } = log.data;
  const oldValue = original ? stableStringify(original) : "{}";
  const newValue = updated ? stableStringify(updated) : "{}";
  return (
    <div className="mt-3 min-w-0 overflow-hidden rounded-md border p-3">
      <h4 className="mb-2 font-semibold text-sm">Changes</h4>
      <div className="overflow-x-auto">
        <ReactDiffViewer
          hideLineNumbers={true}
          hideSummary={true}
          newValue={newValue}
          oldValue={oldValue}
          splitView={false}
          styles={diffStyles}
          useDarkTheme={isDarkMode}
        />
      </div>
    </div>
  );
};
